// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  display: flex;
  border-top: 2px solid #D3D3D3;
  border-radius: 10px!important ;
}

.input {
  border: none;
  border-radius: 8px;
  padding: 3%;
  width: 80%;
  font-size: 1em;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

.addicon {
  color:#F67280;
  margin-top: 10px;
  margin-left: 10px;
}

.sendButton {
  color: #fff !important;
  text-transform: uppercase;
  text-decoration: none;
  background: #2A7A7B;
  padding: 0px;
  display: inline-block;
  border: none;
  width: 20%;
  border-radius:0px 0px 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Chatbot_v2/components/Input/Input.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".form {\n  display: flex;\n  border-top: 2px solid #D3D3D3;\n  border-radius: 10px!important ;\n}\n\n.input {\n  border: none;\n  border-radius: 8px;\n  padding: 3%;\n  width: 80%;\n  font-size: 1em;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\n\n.addicon {\n  color:#F67280;\n  margin-top: 10px;\n  margin-left: 10px;\n}\n\n.sendButton {\n  color: #fff !important;\n  text-transform: uppercase;\n  text-decoration: none;\n  background: #2A7A7B;\n  padding: 0px;\n  display: inline-block;\n  border: none;\n  width: 20%;\n  border-radius:0px 0px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
